import { render, staticRenderFns } from "./ObjectViewer.vue?vue&type=template&id=561d9487&scoped=true&"
import script from "./ObjectViewer.vue?vue&type=script&lang=js&"
export * from "./ObjectViewer.vue?vue&type=script&lang=js&"
import style0 from "./ObjectViewer.vue?vue&type=style&index=0&id=561d9487&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561d9487",
  null
  
)

export default component.exports